import { Navigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import { useContext } from "react";
function PrivateRoute({children}) {
    const{authState}=useContext(AuthContext)
    if(!authState.isAuth){
return <Navigate to="/"/>
    }
    return children
}

export default PrivateRoute;
